var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"tipo-solicitacao-matricula","rota-base":"/admin/tipo-solicitacao-matricula","titulo-singular":"Tipo de Solicitação de Matrícula","campos-extras":[]}})
}
var staticRenderFns = []

export { render, staticRenderFns }